import { createMarkdownSection } from './MarkdownSection';

export const NarrativesSection = createMarkdownSection(
  'narratives.md',
  {
    title: 'Narratives',
    tooltip: 'View and manage engagement narratives for this customer',
    editingStatus: 'Editing narratives...',
    emptyTitle: 'No narratives uploaded',
    emptyDescription: 'Upload a narratives.md file to display content here',
    deleteModalTitle: 'Delete Narratives',
    deleteModalSubtitle:
      'Are you sure you want to delete the narratives file? This action cannot be undone.',
  },
  { filePrefix: 'narratives_' }
);
